import { useEffect, useState } from 'react';
import { useData } from '@apps/context';
import { Box, Button, Stack, Typography } from '@mui/material';
import TickIcon from '@stack/assets/icons/tick-icon.svg';
import { size } from 'lodash';

import { SpecAndFeatureDataType, SpecAndFeatureProps } from '..';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const SpecAndFeatureDesktopView: React.FC<SpecAndFeatureProps> = (
  props
) => {
  const { data, onSelect, selected } = props;
  const { addId, ids } = useData();

  // ======================= VIEWS  const renderSpec = ({
  const RenderSpec = (data: SpecAndFeatureDataType & { index: number }) => {
    const { id, model, price = 0, monthly = 0 } = data;
    const [isAdded, setAdded] = useState(false);
    const isLimited = size(ids) > 3;

    const onClickCompare = (e: { stopPropagation: () => void }) => {
      e?.stopPropagation();
      addId(id?.toString());
    };

    useEffect(() => {
      setAdded(ids?.includes(id?.toString()));
    }, [id, ids]);

    return (
      <Stack
        onClick={(e) => {
          e?.stopPropagation();
          onSelect(data);
        }}
        key={`spec-${id}`}
        sx={{
          border: '1px solid #EDECED',
          borderRadius: 0,
          paddingY: '0.75rem',
          paddingX: '1.25rem',
          transition: 'background-color 0.15s ease-in',
          background: selected?.id === id ? '#F7F7F7' : 'white',
          '&:hover': {
            backgroundColor: '#F7F7F7',
          },
        }}
      >
        <Stack
          sx={{
            width: '100%',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography
            color="#374255"
            fontWeight={500}
            fontSize={'0.875rem'}
            width={'30%'}
            style={{
              width: '45%',
              whiteSpace: 'nowrap',
              textAlign: 'left',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {model}
          </Typography>
          <Typography color="#374255" fontWeight={500} fontSize={'0.875rem'}>
            {Number(price) === 0
              ? 'TBC'
              : `RM${' '}
                    ${Intl.NumberFormat('en-us')
                      .format(Math.round(Number(price)))
                      .toLocaleString()}`}
          </Typography>
          <Typography color="#374255" fontWeight={500} fontSize={'0.875rem'}>
            {Number(monthly) === 0
              ? 'X'
              : `RM${' '}
                    ${Intl.NumberFormat('en-us')
                      .format(Math.round(Number(monthly)))
                      .toLocaleString()}`}
          </Typography>
          {/** TODO: set hover effect */}
          <Button
            onClick={onClickCompare}
            disabled={isAdded || isLimited}
            sx={{
              py: 1.75,
              px: 5.5,
              minWidth: 100,
              backgroundColor: isAdded ? 'white !important' : '#1E242F',
              border: isAdded ? '1px solid #1E242F' : '1px solid #FFF',
              borderRadius: '0px',
              textTransform: 'capitalize',
              color: isAdded ? '#1E242F !important' : 'white',
              '&:hover': {
                backgroundColor: '#919499',
              },
              '&.Mui-disabled': {
                color: 'white',
                backgroundColor: 'grey',
                pointerEvents: 'auto !important',
                cursor: 'not-allowed !important',
              },
            }}
            endIcon={
              isAdded ? (
                <Box
                  component="span"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <TickIcon />
                </Box>
              ) : null
            }
          >
            {isAdded ? 'Added' : 'Compare'}
          </Button>
        </Stack>
      </Stack>
    );
  };

  const renderHeader = () => {
    return (
      <Stack
        sx={{
          border: 'transparent',
          borderRadius: 0,
          paddingX: 5,
        }}
      >
        <Stack
          sx={{
            width: '100%',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography
            color="#374255"
            fontWeight={500}
            fontSize={'0.875rem'}
            width={'30%'}
            style={{
              width: '45%',
              whiteSpace: 'nowrap',
              textAlign: 'left',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            Model
          </Typography>
          <Typography
            color="#374255"
            fontWeight={500}
            fontSize={'0.875rem'}
            width={'10%'}
            textAlign={'center'}
          >
            Car Price
          </Typography>
          <Typography
            color="#374255"
            fontWeight={500}
            fontSize={'0.875rem'}
            width={'10%'}
            textAlign={'center'}
          >
            Monthly
          </Typography>
          <Button
            disabled
            sx={{
              py: 1.75,
              px: 5.5,
              backgroundColor: 'transparent',
              borderRadius: '0px',
              textTransform: 'capitalize',
              color: '#1E242F',
              cursor: 'default !important',
              ':hover': {
                backgroundColor: '#transparent',
              },
              '&.Mui-disabled': {
                color: '#1e242f',
              },
            }}
          >
            Compare
          </Button>
        </Stack>
      </Stack>
    );
  };

  return (
    <Stack spacing={2}>
      {renderHeader()}
      {data?.map((car, index) => (
        <RenderSpec key={index} index={index} {...car} />
      ))}
    </Stack>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default SpecAndFeatureDesktopView;
